import { BaseProfileModel } from '../../index';
import { APP_PERMISSION } from '../../../../../../app/pages/authentication/authentication.config';
export class SAPMPProfileModel extends BaseProfileModel {
    constructor(profile) {
        super(profile);
        const userResponseInfo = profile.user;
        const PERM_GRANT = 'GRANT';
        const PERM_NONE = 'NONE';
        const userPermission = profile.permissions;

        this.firstName = userResponseInfo.firstName;
        this.lastName = userResponseInfo.lastName;
        this.emailAddress = userResponseInfo.email;
        this.contactPhoneNumber = userResponseInfo.phoneNumber;
        this.roles = userResponseInfo.role;
        this.userId = userResponseInfo.id;
        this.companyId = profile.agreement.id;
        this.fans = [];

        /* App Market Permission*/
        const APPM_PERMISSIONS = ['buyAndManange', 'buy', 'manange'];
        const appmPermissionStatus = [userPermission.am_buy === PERM_GRANT &&
        userPermission.am_manage === PERM_GRANT, userPermission.am_buy === PERM_GRANT, userPermission.am_manage === PERM_GRANT];
        const amPermInd = appmPermissionStatus.indexOf(true);

        this.permission = amPermInd === -1 ? PERM_NONE : APP_PERMISSION[APPM_PERMISSIONS[amPermInd]];

        /* Device Track Permission*/
        const ADDP_PERMISSIONS = ['addp_viewOnly', 'addp_partialControl', 'addp_fullControl', 'addp_none'];
        const getADDPPermissions = ADDP_PERMISSIONS.map(i => profile.permissions[i]);
        const permInd = getADDPPermissions.indexOf('GRANT');

        this.addpAuthority = APP_PERMISSION[ADDP_PERMISSIONS[permInd === -1 ? 3 : permInd]];
        //this.fanSignedUpStatus = 'SOME';

        let user = JSON.parse(sessionStorage.getItem('user'));
        if (user !== null) {
          if (user.user.fanSignedUpStatus) {
            this.fanSignedUpStatus = user.user.fanSignedUpStatus;
          } 
        } else {
          this.fanSignedUpStatus = 'SOME';
        }

        this.impersonator = profile.impersonator;
        this.fanList = profile.fans || [];
        this.agreement = profile.agreement;
        if (profile.agreement && profile.agreement.fans) {
            for (let fan of profile.agreement.fans) {
            this.fans.push(fan);
            this.fanList.push(fan.fanId);
            }
        }
    }
    static getUnknownUser() {
        const u:any = {
            "jwtToken" : "Jwt 1MjZe3B0Wj6oO_0iHupr7nbDeW1OozJ9xSb4iJbaFrHUwth5clgQ1tLY51Fd0uR7NzuPW5Zm9eG9JqutBFzabp9kLLJSwu-065GPk2XcUXtq_DsaodnNfF-WQ4ORbb01eRV5JAZ8705-whyL7avCgr3L7bWT5s-4IekF_SvvFvQD1HVuO7dcGWXL8HdM2nBGUiqiCaG7fxSt9gwH9ficVk96aZQ5Uc2b92UPxoW4fI--Pepbx7ERlWuIrJbFf3PujzkJ5WQl5BaVn8R_Qus38-NHbOZ3TcF5TfEMypeIPQ1b3TNnxpwdVZAzVRBwEVvhs68Rc_07i3TBUSCnG7WTEFF2oyNTCYxmTms_f2NexIJ55Tch3OyT7WWLCmY2DPlgY_BbOcRCf0OldBrW1K-C-jzhBP3QqiUTCv1Xh8BPlmaucUzeXSiZGKr8sFksOe6LgwbeL4QkJ4aIGgTkc0lupTbjNkYphrfS0p72qPQL-QzOsNB88pzmypi1hR6vr7EHml1WqYWWWT9cEcCwL8MsKwMyFUBwZMoCnLpOsw5PxFZvZ5r7IWfkKBbzTpWW2UkpeDTOSJp81awtzkE5yM1ynff6j07oZgue3H6KD9D24zcelzt8hCBkvitMKoyvdTq3wCRmiTpRcP8MI5xAHaKY8g==",
            "permissions" : {
              "perm" : [ {
                "action" : "show",
                "instance" : "support",
                "type" : "com.att.sapmp.add.page"
              }, {
                "action" : "disable",
                "instance" : "alerts.action",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide", "instance" : "dashboard", "type" : "com.att.sapmp.appmarket.page" 
              },
                        {
                "action" : "hide",
                "instance" : "appleCertificate",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "cancelParticipation",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo.fanDeploymentProfile",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo.lockDevice",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo.reports",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo.sendMessage",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "ctnInfo.wipeDevice",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "ctnlookup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.appleCertificate",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.cancelParticipation",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.fanDeploymentProfile",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.report",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.signup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "dashboard.welcome",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "deviceInventory",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "deviceInventory.cancelParticipation",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "deviceInventory.ctnLookup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "deviceInventory.DownloadTermsconditions",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "deviceInventory.fanDeploymentProfile",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "deviceInventory.signup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "fanDeploymentProfile",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "fanDeploymentProfile.deviceInventory",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "show",
                "instance" : "faq",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "show",
                "instance" : "faq.GET",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "show",
                "instance" : "home",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "show",
                "instance" : "learn",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "manageInventory",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.appleCertificate",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.cancelParticipation",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.ctnLookup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.deviceInventory",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.fanDeploymentProfile",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "manageInventory.signup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "signup",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "hide",
                "instance" : "welcome",
                "type" : "com.att.sapmp.addp.page"
              }, {
                "action" : "disable",
                "instance" : "welcome.signup",
                "type" : "com.att.sapmp.addp.page"
              } ]
            },
            "profile" : {
              "user" : {
                "id" : "Unauthenticated",
                "firstName" : "Unknown",
                "lastName" : "User",
                "role" : "Unknown",
                "generatedTime" : "4070951823000",
                "sessionId" : "sapmp_Unauthenticated~04142020~022e8b86-a41a-49e9-b92b-326fc87426fa"
              },
              "agreement" : { },
              "permissions" : {
                "am_manage" : "DENY",
                "am_buy" : "DENY"
              },
              "requestInfo" : { },
              "impersonator" : { }
            },
            "fans" : [ "NO_FANS" ]
          }
        return u;
    } 
}
